import type { ReduxAction } from '../../types';
import { Map } from 'immutable';

type ViewID = string;
type ScrollPosition = number;
export type ScrollPositionState = Map<ViewID, ScrollPosition>;

export function scrollPositionReducer(
  state: ScrollPositionState = Map(),
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'SAVE_SCROLL_POSITION':
      return state.set(payload.viewID, payload.scrollPosition);

    default:
      return state;
  }
}
